import React from 'react';
import {colors} from '../styles/colors';
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack} from '../navigation/NavigationActions';
import {connect} from 'react-redux';
import {
	FacebookShareButton,
	WhatsappShareButton,
	EmailShareButton,
	FacebookIcon,
	WhatsappIcon,
	EmailIcon,
} from 'react-share';
import {saveHideShare, getHideShare} from '../utils/settingsStore';
import {ListItem} from 'material-ui';
import {InfoOutline} from 'material-ui-icons';
import {getUserSync} from '../utils/auth';
import Rater from 'react-rater';
import 'react-rater/lib/react-rater.css';
import MyButton from '../components/MyButton';
import './RatingScreen.css';
import TooEasyImg from './img/level-tooeasy.png';
import TooHardImg from './img/level-toohard.png';
import PerfectImg from './img/level-perfect.png';
import {Radio} from 'material-ui';
import RatingSelectable from './RatingSelectable';
import {feedbackFetchData} from './FeedbackAction';
import InfoSnack from '../utils/InfoSnack';

class RatingScreen extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			showComment: false,
			itWas: 1,
		};
	}

	handleChange = (name) => (event) => {
		this.setState({[name]: event.target.checked}, () => {
			saveHideShare(this.state.checkedA);
		});
	};

	componentDidMount() {
		let hideShare = getHideShare();
		this.setState({['checkedA']: hideShare});
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.loadingFeedbackFailed !==
				this.props.loadingFeedbackFailed &&
			prevProps.isLoading
		) {
			this.infoSnack.showSnack(this.props.t('common:cell_failed'));
		}
	}

	getShareUrl() {
		return 'https://toplife.zone/live/' + getUserSync()._id;
	}

	onComment = () => {
		window.open(
			'https://www.facebook.com/Toplife.Zone/posts/2844155809012346',
			'_blank'
		);
	};

	handleRate({rating}) {
		if (rating === 5) {
			this.setState({showComment: true});
		} else {
			this.props.goBack();
		}
	}

	setFeedback = () => {
		const {day} = this.props.match.params;
		this.props.fetchFeedback(this.state.itWas, day);
	};

	render() {
		const {t} = this.props;
		return (
			<div className='ratingWrapper'>
				<div className='ratingInfoWrapper'>
					<InfoSnack onRef={(ref) => (this.infoSnack = ref)} />
					<div className='contentWrapper'>
						<h1>{t('howWasIt:title')}</h1>
						<div className='ratingSelectables'>
							<RatingSelectable
								src={TooEasyImg}
								label={t('howWasIt:easy')}
								value={1}
								onChange={(val) =>
									this.setState({
										itWas: val,
									})
								}
								selectedValue={this.state.itWas}
							/>
							<RatingSelectable
								src={PerfectImg}
								value={0}
								label={t('howWasIt:medium')}
								onChange={(val) =>
									this.setState({
										itWas: val,
									})
								}
								selectedValue={this.state.itWas}
							/>
							<RatingSelectable
								value={-1}
								src={TooHardImg}
								label={t('howWasIt:hard')}
								onChange={(val) =>
									this.setState({
										itWas: val,
									})
								}
								selectedValue={this.state.itWas}
							/>
						</div>
						<div className='ratingSubmitContainer'>
							<br />
							<MyButton
								title={t('common:save')}
								style={{backgroundColor: '#fff'}}
								size='large'
								color='primary'
								loading={this.props.isLoading}
								onPressButton={() => this.setFeedback()}
							/>
						</div>
					</div>
				</div>
			</div>
		);
		return (
			<div>
				<div className='toolbar'>
					<div
						className='back-arrow'
						onClick={() => this.props.goBack()}
					>
						<ArrowBack />
					</div>

					<h2 style={styles.flex}>{t('rating:title')}</h2>
				</div>
				<div style={styles.shareContainer}>
					<h1 style={styles.flex}>{t('rating:descriptionTitle')}</h1>

					<div style={styles.share}>
						<Rater
							total={5}
							rating={0}
							onRate={this.handleRate.bind(this)}
						/>
					</div>

					{this.state.showComment === true && (
						<div style={styles.highlight}>
							<p>
								<strong>{t('rating:commentTitle')}</strong>
							</p>
							<p>{t('rating:commentUsTitle')}</p>
							<p style={styles.thanks}>
								<strong>{t('rating:commentUsThanks')}</strong>
							</p>

							<MyButton
								title={t('rating:commentCta')}
								variant='raised'
								size='large'
								color='primary'
								fullWidth={true}
								loading={false}
								onPressButton={() => this.onComment()}
							/>
						</div>
					)}

					{/*<p style={styles.smSkip} onClick={() => this.props.goBack()}>{t('friends:skipShare')}</p>*/}

					{/*<div  style={styles.hideShareLayout}>
                     <FormControlLabel
                     control={
                     <Checkbox
                     checked={this.state.checkedA}
                     onChange={this.handleChange('checkedA')}
                     color="default"
                     value="checkedA"
                     />
                     }
                     label={t('friends:hideShare')}
                     />
                     </div>*/}
				</div>
			</div>
		);
	}
}

const styles = {
	shareContainer: {
		maxWidth: 512,
		margin: '0 auto',
		paddingTop: 72,
		paddingRight: 16,
		paddingLeft: 16,
	},
	flex: {
		flex: 1,
	},
	share: {
		marginTop: 16,
		marginBottom: 16,
	},
	highlight: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		padding: 16,
		backgroundColor: colors.white,
		boxShadow: `0 1px 3px 0 rgba(41,70,97,.2)`,
		borderRadius: 3,
	},
	icon: {
		marginRight: 16,
	},
	smLayout: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		outline: 'none',
	},
	smText: {
		paddingLeft: 16,
	},
	smListButton: {
		paddingLeft: 16,
	},
	smSkip: {
		paddingTop: 16,
		paddingBottom: 16,
		textDecoration: 'underline',
		cursor: 'pointer',
		textAlign: 'center',
		color: colors.text_light,
	},
	hideShareLayout: {
		paddingTop: 32,
	},
	thanks: {
		paddingBottom: 16,
	},
};

const mapStateToProps = (state) => {
	return {
		loadingFeedbackFailed: state.loadingFeedbackFailed,
		isLoading: state.feedbackLoading,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchFeedback: (feedback, day) =>
			dispatch(feedbackFetchData(feedback, day)),
		goBack: () => dispatch(navigationBack()),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(translate(['rating', 'friends', 'common'])(RatingScreen));



// WEBPACK FOOTER //
// ./src/rating/RatingScreen.js